import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
type Props = {
  spotsLeft?: number;
  totalSpots?: number;
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  spotsLeft = 9,
  totalSpots = 120,
  tone = 'light'
}: Props) {
  const taken = totalSpots - spotsLeft;
  const percent = Math.round(taken / totalSpots * 100);
  const isDark = tone === 'dark';
  return <div className="w-full" data-id="element-52" data-mp="2b68idmgmlqfj">
      <div className="mb-2 flex items-start justify-between gap-3" data-id="element-53" data-mp="2b56wso1zhljk">
        <p className={`flex items-center gap-1.5 text-[11.5px] font-bold uppercase tracking-[0.08em] sm:text-xs ${isDark ? 'text-gold-300' : 'text-gold-600'}`} data-id="element-54" data-mp="2g63bzxrscu4a">
          <FlameIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-55" data-mp="274db81c0kitu" />
          Quedan {spotsLeft} cupos
        </p>
        <p className={`text-[11.5px] font-semibold sm:text-xs ${isDark ? 'text-white/70' : 'text-navy-500'}`} data-id="element-56" data-mp="g09zt300mjv">
          {percent}% reclamado
        </p>
      </div>
      <div className={`h-3.5 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy-100'}`} role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label={`Cupos reclamados al precio promocional: ${percent}%`} data-id="element-57" data-mp="33lbpwr176w2w">
        <motion.div initial={{
        width: 0
      }} whileInView={{
        width: `${percent}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 1.1,
        ease: 'easeOut'
      }} className="h-full rounded-full bg-gold-500" data-id="element-58" data-mp="38fxv2cgorsej" />
      </div>
      <p className={`mt-2 text-[11.5px] font-medium leading-relaxed sm:text-xs ${isDark ? 'text-white/70' : 'text-navy-500'}`} data-id="element-59" data-mp="2unhwpoyqcijy">
        Solo faltan <strong className={isDark ? 'text-white' : 'text-navy-800'} data-id="element-60" data-mp="9uwmnvdkcm6i">{spotsLeft} cupos</strong>{' '}
        para cerrar el precio promocional de lanzamiento.
      </p>
    </div>;
}